import dsMenu from "./ds-menu";
import duMenu from "./du-menu";
import duRouters from "./erp/du-menu";

const routers = [
  {
    title: "首頁",
    to: "tca",
    icon: { icon: "tabler-smart-home" },
    action: "manage",
    subject: "root",
  },
  {
    title: "授權管理系統",
    icon: { icon: "tabler-settings" },
    action: "manage",
    subject: "DS",
    children: [
      {
        title: "系統管理",
        to: "erp-ds-menu-view-ds-sys",
        action: "manage",
        subject: "DSMENU",
      },
      // {
      //   title: "系統授權",
      //   to: { name: "erp-ds-menu-view-id", params: { id: "DS" } },
      //   action: "manage",
      //   subject: "DSGROUP",
      // },
      {
        title: "角色管理",
        to: "erp-ds-auth-view-ds-role",
        action: "manage",
        subject: "DSGROUP",
      },
      // {
      //   title: "角色授權",
      //   to: {
      //     name: "erp-ds-auth-view-role-id",
      //     params: { roleId: "Administrator" },
      //   },
      //   action: "manage",
      //   subject: "DSGROUP",
      // },
    ],
  },
  {
    title: "組織管理系統",
    icon: { icon: "tabler-settings" },
    action: "manage",
    subject: "DU",
    children: [
      {
        title: "組織管理",
        to: "erp-du-org-view-du-org",
        action: "manage",
        subject: "DUDEPARTMENT",
      },
      {
        title: "人員管理",
        to: "erp-du-user-view-du-user-management",
        action: "manage",
        subject: "DUDEPARTMENT",
      },
      {
        title: "帳號審核",
        to: "erp-du-user-view-du-user-register",
        action: "manage",
        subject: "DUUSERREGISTER",
      },
      {
        title: '職稱管理',
        to: {
          path: '/erp/du/org/view/du-position',
        },
        action: 'manage',
        subject: 'DUPOSITION',
      },
      {
        title: '藥檢管理',
        to: {
          path: '/nstc/view/rtp',
        },
        action: 'manage',
        subject: 'NSTCRTP',
      },
      {
        title: '代理人設定',
        to: 'erp-du-user-view-assignee-proxy-setting',
        action: 'manage',
        subject: 'ASSIGNEEPROXYSETTING',
      },
      {
        title: '代理清單',
        to: 'erp-du-user-view-assignee-proxy-list',
        action: 'manage',
        subject: 'ASSIGNEEPROXYSETTING',
      },
    ],
  },
];

const modulesFiles = import.meta.glob([ 
  "./tca/*.ts", "./erp/de-menu.ts", "./nstc/*.ts",
], {
  eager: true,
});

Object.keys(modulesFiles).forEach((key) => {
  const module = modulesFiles[key];
  if (key.startsWith('./erp')) {
    routers.push(module.default[0]);
  } else {
    routers.splice(1, 0, module.default[0]);
  }
});

// Object.keys(modulesFiles).forEach(path => {
//   console.log('path: ', path)
// })

// modulesFiles.keys().reduce((modules, modulePath) => {
//   if (!modules) { modules = [] }
//   // set './app.js' => 'app'
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
//   const value = modulesFiles(modulePath)
//   routers.push(value.default)
// }, {})

export default routers;

// export default [
//   {
//     title: 'Home',
//     to: { name: 'root' },
//     icon: { icon: 'tabler-smart-home' },
//   },
//   {
//     title: 'Second page',
//     to: { name: 'second-page' },
//     icon: { icon: 'tabler-file' },
//   },
//   ...duMenu,
//   ...dsMenu,
// ]
